<template>
  <div class="form-group">
    <label>{{ labelTranslated }}</label>
    <div class="input-group input-group-sm">
      <input
        class="form-control"
        :type="type"
        :placeholder="placeholder"
        v-model="localModel"
        readonly
      >
    </div>
  </div>
</template>

<script>

export default {
  name: 'CustomInput',
  props: ['label', 'type', 'placeholder', 'field', 'model'],
  computed: {
    labelTranslated() {
      return (this.label !== undefined) ? this.label : this.$gettext(this.field);
    },
    localModel() {
      if(this.model !== undefined) {
        return this.model;
      } else {
        const bill = this.$store.state.bill.bill;
        if(this.field == 'staff' && bill.staff) {
          return this.printProperty(bill.staff, 'staffs', 'ref');
        } else {
          return bill[this.field];
        }
      }
    },
  },
};
</script>

<style scoped>
label {
  text-transform: capitalize;
}
</style>
